module.exports = __webpack_public_path__ + "img/icon-delete-light.1b6ce010.svg";